import { ComponentProps } from 'react';
import { Button } from 'react-aria-components';

import InlineIcon from '../../../InlineIcon/InlineIcon';

import leftIcon from './graphics/left.svg?raw';
import rightIcon from './graphics/right.svg?raw';

import styles from './PrevNextButton.module.css';

type PrevNextButtonProps = {
    direction: 'previous' | 'next';
} & Omit<ComponentProps<typeof Button>, 'children' | 'className'>;

const PrevNextButton = ({
    direction,
    slot = null,
    ...buttonProps
}: PrevNextButtonProps) => {
    return (
        <Button slot={slot} className={styles.Root} {...buttonProps}>
            <InlineIcon
                src={direction === 'previous' ? leftIcon : rightIcon}
                size="small"
            />
        </Button>
    );
};

export default PrevNextButton;
